const type = {
  FETCHCAMERAS: "FETCHCAMERAS",
  ADDCAMERA: "ADDCAMERA",
  EDITCAMERA: "EDITCAMERA",
  DELETECAMERA: "DELETECAMERA",
  GET_SCHEDULER_DATA: "GET_SCHEDULER_DATA",
};

export default type;
